/** @flow */
import Highlighter from './Highlighter'
import { combineChunks, fillInChunks, findAll, findChunks } from './utils'

export default Highlighter
export { combineChunks, fillInChunks, findAll, findChunks }



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/


// WEBPACK FOOTER //
// webpack:///src/index.js